import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { useSelector } from 'react-redux';
import { agylePref } from '../../../../store/reducers/preferences';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Chip, FormLabel, Stack } from '@mui/material';
import { useSettingsStyles } from '../useSettingsStyles';
import { OPTION_BUTTONS_DEFAULT_GAP } from '../agyleMenuUtil';
import _isNull from 'lodash/isNull';

const DEFAULT_STATE = {
    patientLobbyMode: 'auto',
};

const PatientLobbyMode = forwardRef((props, ref) => {
    const classes = useSettingsStyles();
    const { t } = useTranslation();
    const agylePreference = useSelector(agylePref);

    const [mode, setMode] = useState(
        !_isNull(agylePreference?.patientLobbyMode) ? agylePreference?.patientLobbyMode : DEFAULT_STATE.patientLobbyMode,
    );

    // Return the default state of a component
    useImperativeHandle(ref, () => ({
        defaultState: () => {
            setMode(DEFAULT_STATE.patientLobbyMode);
            return DEFAULT_STATE;
        },
    }));

    const handleChange = (val) => {
        setMode(val);
        props.onChange('patientLobbyMode', val);
    };

    return (
        <div>
            <FormLabel>{t('Select the default behaviour of the Patient Lobby on the whiteboard')}</FormLabel>

            <Stack direction="row" gap={OPTION_BUTTONS_DEFAULT_GAP} sx={{ mt: 1, my: 0.5 }}>
                <Chip
                    label="Manual"
                    className={clsx(mode === 'manual' && classes.activeChip)}
                    onClick={handleChange.bind(null, 'manual')}
                />

                <Chip label="Automatic" className={clsx(mode === 'auto' && classes.activeChip)} onClick={handleChange.bind(null, 'auto')} />
            </Stack>
        </div>
    );
});

export default PatientLobbyMode;
